import { useCallback, useEffect, useState } from 'react';

export type EmbedLoadStatus = 'loading' | 'loaded' | 'failed';

export const useEmbedLoadState = (resetKey: string, timeoutMs: number) => {
  const [status, setStatus] = useState<EmbedLoadStatus>('loading');

  useEffect(() => {
    setStatus('loading');
    const timeoutId = window.setTimeout(() => {
      setStatus((current) => (current === 'loading' ? 'failed' : current));
    }, timeoutMs);

    return () => window.clearTimeout(timeoutId);
  }, [resetKey, timeoutMs]);

  const markLoaded = useCallback(() => {
    setStatus((current) => (current === 'failed' ? current : 'loaded'));
  }, []);

  return { status, markLoaded };
};
